'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToPageTop = void 0;
const $ = require("jquery");
class ToPageTop {
    constructor() {
        // 少しスクロールしたらボタン表示
        $(window).on('load scroll', function () {
            if ($(this).scrollTop() > 100) {
                $('.trigToPageTopButton').attr('data-is-show', 'true');
            }
            else {
                $('.trigToPageTopButton').attr('data-is-show', 'false');
            }
        });
        // ボタンを押したら一番上に戻る
        $('.trigToPageTopButton').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        });
    }
}
exports.ToPageTop = ToPageTop;
exports.default = ToPageTop;
